<template>
  <div class="row">
    <div class="col-2">
      <div class="form-group">
        <div
            class="btn-group-vertical buttons"
            role="group"
            aria-label="Basic example"
        >
          <button class="btn btn-secondary" @click="add">Add</button>
          <button class="btn btn-secondary" @click="replace">Replace</button>
        </div>

        <div class="form-check">
          <input
              id="disabled"
              type="checkbox"
              v-model="enabled"
              class="form-check-input"
          />
          <label class="form-check-label" for="disabled">DnD enabled</label>
        </div>
      </div>
    </div>

    <div class="col-6">

      <draggable
          :list="list"
          item-key="name"
          tag="transition-group"
          :component-data="{
          tag: 'ul',
          type: 'transition-group',
          name: 'flip-list'
        }"
          class="list-group"
          ghost-class="ghost"
          :move="handleMove"
          @start="handleDragStart"
          @end="handleDragEnd"
      >
        <template #item="{ element ,index }">
          <ul class="list-group-item" :class="{ 'not-draggable': !enabled }">
            <li>
              <div class="drop-area  py-5 px-6 bg-gray-800"
                   :class="{'border-dotted border-4 border-blue-500':  index === futureIndex && dragType==='drop-area' }">
              </div>
              <div class="merge-area py-5 px-6  bg-red-400"
                   :class="{'border-dotted border-4 border-black':  index === futureIndex && dragType==='merge-area'}">

                {{ element.name }}
              </div>
            </li>
          </ul>
        </template>
      </draggable>
    </div>

    <div class="col-3" :value="list" title="List"/>
  </div>
</template>

<script>
import draggable from "vuedraggable";

let id = 1;
export default {
  name: "simple",
  display: "Simple",
  order: 0,
  components: {
    draggable
  },
  data() {
    return {
      movingIndex: null,
      futureIndex: null,
      dragType: null,
      enabled: true,
      list: [
        {name: "A", id: 1},
        {name: "B", id: 2},
        {name: "C", id: 3},
        {name: "D", id: 4},
        {name: "E", id: 5,},
        {name: "F", id: 6},
      ],
      dragging: true
    };
  },
  computed: {
    draggingInfo() {
      return this.dragging ? "under drag" : "";
    }
  },
  methods: {
    add: function () {
      this.list.push({name: "Juan " + id, id: id++});
    },
    replace: function () {
      this.list = [{name: "Edgard", id: id++}];
    },
    checkMove: function (e) {
      window.console.log("Future index: " + e.draggedContext.futureIndex);
    },
    handleDragEnd(evt) {

      // console.log(evt);
      // console.log(this.dragType);
      // console.log(this.futureIndex);
      // console.log(this.movingIndex);



      if (this.movingIndex >= 0 && this.futureIndex >= 0 && this.futureIndex !== this.movingIndex) {
        const _items = Object.assign([], this.list);
        switch (this.dragType) {
          case 'drop-area':
            this.futureItem = this.list[this.futureIndex];
            this.movingItem = this.list[this.movingIndex];
            _items[this.futureIndex] = this.movingItem;
            _items[this.movingIndex] = this.futureItem;
            this.list = _items;
            break;
          case 'merge-area':
            if(confirm('are u sure?')){
              this.movingItem = this.list[this.movingIndex];
              this.futureItem = this.list[this.futureIndex];

              _items[this.futureIndex] = {
                id: this.futureItem.id,
                name: this.futureItem.name + ' | ' + this.movingItem.name
              };
              _items.splice(this.movingIndex, 1);
              this.list = _items;
            }
            break;
          default:
            break;
        }
        this.movingIndex = null;
        this.futureIndex = null;
      }

    },
    handleDragStart() {
      this.movingIndex = null;
      this.futureIndex = null;
    },
    handleMove(e) {
      const {index, futureIndex} = e.draggedContext;
      //
       console.log(e);
      const dragType = e.originalEvent.srcElement.classList[0] ?? null;
      this.movingIndex = index;
      this.futureIndex = futureIndex;

      // console.log(this.movingIndex);
      // console.log(this.futureIndex);
      // console.log(this.dragType);
      this.dragType = dragType;

      return false; // disable sort
    },
    // remove(e){
    //   console.log(e)
    // },
    // unchoose(e){
    //   console.log(e)
    // },
    // choose(e){
    //   console.log(e)
    // },
    // sort(e){
    //   console.log(e)
    // },
    // update(e){
    //   console.log(e)
    // }
  }
};
</script>
<style scoped>
/*.buttons {*/
/*  margin-top: 35px;*/
/*}*/


/*.ghost {*/
/*  opacity: 0.5;*/
/*  background: #c8ebfb;*/
/*}*/


.button {
  margin-top: 35px;
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
}

.list-group-item i {
  cursor: pointer;
}
</style>
